import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Layout from './components/Layout/Layout';
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Homepage from './components/Pages/Homepage/HomePage';
import Login from './components/Pages/Login/Login';
import ProductListingPage from './components/Pages/Product/ProductListing/ProductListingPage';
import CreateProductPage from './components/Pages/Product/CreateProduct/CreateProductPage';
import CategoryListingPage from './components/Pages/Category/CategoryListing/CategoryListingPage';
import FilterListingPage from './components/Pages/Filter/FilterListingPage';
import ColorListingPage from './components/Pages/Color/ColorListingPage';
import CollectionPartnerListing from './components/Pages/CollectionPartner/CollectionPartnerListing';
import ProductDetailsPage from './components/Pages/Product/ProductDetails/ProductDetailsPage';
import RawMaterialCategory from './components/Pages/RM/RawMaterialCategory/rawMaterialCategory';
import RawMaterialVendor from './components/Pages/RM/RawMaterialVendor/RawMaterialVendor';
import RawMaterial from './components/Pages/RM/RawMaterial/RawMaterial';
import PortfolioListing from './components/Pages/Portfolio/PortfolioListing/PortfolioListing';
import PortfolioDetails from './components/Pages/Portfolio/PortfolioDetails/PortfolioDetails';
import CreatePortfolio from './components/Pages/Portfolio/CreatePortfolio/CreatePortfolio';
import DummyRunner from './components/Pages/Product/DummyRunner/DummyRunner';
import OfficeListing from './components/Pages/Office/OfficeListing/OfficeListing';
import CreateOffice from './components/Pages/Office/CreateOffice/CreateOffice';
import OfficeDetailsPage from './components/Pages/Office/OfficeDetails/OfficeDetails';
import BlogListingPage from './components/Pages/Blog/BlogListing/BlogListingPage';
import CreateBlogPage from './components/Pages/Blog/CreateBlog/CreateBlogPage';
import BlogDetailsPage from './components/Pages/Blog/BlogDetails/BlogDetailsPage';
import BlogCategoryListingPage from './components/Pages/Blog/BlogCategoryListing/BlogCategoryListingPage';
import LeadListingPage from './components/Pages/Lead/LeadListing/LeadListing';
import LeadDetailsPage from './components/Pages/Lead/LeadDetails/LeadDetails';
import ProjectListing from './components/Pages/ProjectListing/ProjectListing';
import ProjectDetails from './components/Pages/ProjectDetails/ProjectDetails';
import ProjectBoardDetails from './components/Pages/ProjectBoardDetails/ProjectBoardDetails';
import MeasurementRequests from './components/Pages/MeasurementRequest/MeasurementRequest';
import MeasurementRequestDetailsPage from './components/Pages/MeasurementRequest/MeasurementRequestDetails/MeasurementRequestDetails';
import ConfiguratorPage from './components/Pages/ConfiguratorPage/ConfiguratorPage';
import ProjectBoardPage from './components/Pages/ProjectBoardDetails/ProjectBoard';
import PortalUserListingPage from './components/Pages/PortalUser/PortalUserListing/PortalUserListing';
import InventoryListing from './components/Pages/RM/Inventory/InventoryListing';
import Unauthorized from './components/Pages/Unauthorized/Unauthorized';

function App() {


  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Homepage />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          <Route path="/products" element={<ProductListingPage />} />
          <Route path="/create-product" element={<CreateProductPage />} />
          <Route path='/product/:id/dummy-runner' element={<DummyRunner />} />
          <Route path="/product/:id/configurator" element={<ConfiguratorPage />} />
          <Route path="/products/:id/edit" element={<CreateProductPage />} />
          <Route path="/product/:id" element={<ProductDetailsPage />} />

          <Route path="/category" element={<CategoryListingPage />} />
          <Route path="/filter" element={<FilterListingPage />} />
          <Route path="/color" element={<ColorListingPage />} />
          <Route path="/collection-partner" element={<CollectionPartnerListing />} />

          <Route path="/raw-material-categories" element={<RawMaterialCategory />} />
          <Route path="/raw-material-vendors" element={<RawMaterialVendor />} />
          <Route path="/raw-material" element={<RawMaterial />} />
          <Route path="/inventory" element={<InventoryListing />} />

          <Route path='/portfolio' element={<PortfolioListing />} />
          <Route path='/portfolio/:id' element={<PortfolioDetails />} />
          <Route path='/create-portfolio' element={<CreatePortfolio />} />

          <Route path="/offices" element={<OfficeListing />} />
          <Route path="/create-office" element={<CreateOffice />} />
          <Route path="/offices/:id/edit" element={<CreateOffice />} />
          <Route path="/offices/:id" element={<OfficeDetailsPage />} />

          <Route path="/blogs" element={<BlogListingPage />} />
          <Route path="/create-blog" element={<CreateBlogPage />} />
          <Route path="/blogs/:id/edit" element={<CreateBlogPage />} />
          <Route path="/blogs/:id" element={<BlogDetailsPage />} />
          <Route path="/blog-categories" element={<BlogCategoryListingPage />} />

          <Route path="/leads" element={<LeadListingPage />} />
          <Route path="/leads/:id" element={<LeadDetailsPage />} />

          <Route path="/projects" element={<ProjectListing />} />
          <Route path="/projects/:id" element={<ProjectDetails />} />
          <Route path="/project-board/:id" element={<ProjectBoardPage />} />

          <Route path="/measurement-requests" element={<MeasurementRequests />} />
          <Route path="/measurement-requests/:id" element={<MeasurementRequestDetailsPage />} />

          <Route path="/portal-users" element={<PortalUserListingPage />} />


        </Route>
        <Route path='/login' element={<Login />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;